import moment from "moment";

// Helper function to convert YYYY-MM-DD to DD-MM-YYYY (for display and backend)
export const convertYYYYMMDDToDDMMYYYY = (dateString) => {
  if (!dateString) return "";

  // Check if already in DD-MM-YYYY format
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    return dateString;
  }

  // Check if in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  }

  // Check if in DD/MM/YYYY format (backward compatibility)
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString.replace(/\//g, "-");
  }

  // Try to parse as Date and convert (avoid timezone issues)
  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    // Use local date components to avoid timezone shift
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return dateString;
};

// Helper function to convert DD-MM-YYYY to YYYY-MM-DD (for date input)
export const convertDDMMYYYYToYYYYMMDD = (dateString) => {
  if (!dateString) return "";

  // Check if already in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }

  // Check if in DD-MM-YYYY format
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  }

  // Check if in DD/MM/YYYY format (backward compatibility)
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  }

  return "";
};

// Helper function to format date input as user types (DD-MM-YYYY)
export const formatDateInput = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");

  // Limit to 8 digits (DDMMYYYY)
  const limitedDigits = digits.slice(0, 8);

  // Format as DD-MM-YYYY
  if (limitedDigits.length <= 2) {
    return limitedDigits;
  } else if (limitedDigits.length <= 4) {
    return `${limitedDigits.slice(0, 2)}-${limitedDigits.slice(2)}`;
  } else {
    return `${limitedDigits.slice(0, 2)}-${limitedDigits.slice(
      2,
      4
    )}-${limitedDigits.slice(4)}`;
  }
};

// Helper function to validate DD-MM-YYYY date format
export const validateDate = (dateString) => {
  if (!dateString) return false;

  const datePattern = /^(\d{2})-(\d{2})-(\d{4})$/;
  const match = dateString.match(datePattern);

  if (!match) return false;

  const [, day, month, year] = match;
  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);

  // Basic validation
  if (
    dayNum < 1 ||
    dayNum > 31 ||
    monthNum < 1 ||
    monthNum > 12 ||
    yearNum < 1900 ||
    yearNum > 2100
  ) {
    return false;
  }

  // Validate actual date
  const date = new Date(yearNum, monthNum - 1, dayNum);
  return (
    date.getFullYear() === yearNum &&
    date.getMonth() + 1 === monthNum &&
    date.getDate() === dayNum
  );
};

// Helper function to format date with time to DD-MM-YYYY HH:MM (12hr format)
export const formatDateTimeToDDMMYYYY12Hr = (dateString) => {
  if (!dateString) return "";
  return moment(dateString).format("DD-MM-YYYY hh:mm A");
  // const date = new Date(dateString);
  // if (isNaN(date.getTime())) return "";

  // // Use local date components to avoid timezone shift
  // const day = String(date.getDate()).padStart(2, "0");
  // const month = String(date.getMonth() + 1).padStart(2, "0");
  // const year = date.getFullYear();

  // // Format time in 12-hour format
  // let hours = date.getHours();
  // const minutes = String(date.getMinutes()).padStart(2, "0");
  // const ampm = hours >= 12 ? "PM" : "AM";
  // hours = hours % 12;
  // hours = hours ? hours : 12; // the hour '0' should be '12'
  // const formattedHours = String(hours).padStart(2, "0");

  // return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
};

// Helper function to format date to DD-MM-YYYY (for display in tables/lists)
export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return "";

  // Check if already in DD-MM-YYYY format
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    return dateString;
  }

  // Check if in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  }

  // Check if in DD/MM/YYYY format (backward compatibility)
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString.replace(/\//g, "-");
  }

  // Try to parse as Date and convert (avoid timezone issues)
  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    // Use local date components to avoid timezone shift
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return dateString;
};
